import React from 'react'
import {
  CAvatar,
  CBadge,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react'
import {
  cilBell,
  cilCreditCard,
  cilCommentSquare,
  cilEnvelopeOpen,
  cilFile,
  cilLockLocked,
  cilSettings,
  cilTask,
  cilUser,
  cilMoney
} from '@coreui/icons'
import CIcon from '@coreui/icons-react'

import alecMavatar from './../../assets/images/avatars/AlecM-avatar.png'

const AppHeaderDropdown = () => {
  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle placement="bottom-end" className="py-0" caret={false}>
              <CAvatar src={alecMavatar} size="md" />
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        <CDropdownHeader className="bg-light fw-semibold py-2">Discord</CDropdownHeader>
              <CDropdownItem>
                  <CIcon icon={cilUser} className="me-2" /> @amenconi
              </CDropdownItem>
              <CDropdownItem>
                Message me on Discord for feature requests or bugs found.
              </CDropdownItem>
            <CDropdownHeader className="bg-light fw-semibold py-2">Donations</CDropdownHeader>
              <CDropdownItem>
                  <CIcon icon={cilMoney} className="me-2" /> 0xaB0221e929c2A754F742cac0947593784755A0c2
              </CDropdownItem>
              <CDropdownItem>
                    Help with hosting costs always appreciated.
              </CDropdownItem>
        {/*<CDropdownItem href="#">*/}
        {/*  <CIcon icon={cilBell} className="me-2" />*/}
        {/*  Updates*/}
        {/*  <CBadge color="info" className="ms-2">*/}
        {/*    42*/}
        {/*  </CBadge>*/}
        {/*</CDropdownItem>*/}
        {/*<CDropdownItem href="#">*/}
        {/*  <CIcon icon={cilEnvelopeOpen} className="me-2" />*/}
        {/*  Messages*/}
        {/*  <CBadge color="success" className="ms-2">*/}
        {/*    42*/}
        {/*  </CBadge>*/}
        {/*</CDropdownItem>*/}
        {/*<CDropdownItem href="#">*/}
        {/*  <CIcon icon={cilTask} className="me-2" />*/}
        {/*  Tasks*/}
        {/*  <CBadge color="danger" className="ms-2">*/}
        {/*    42*/}
        {/*  </CBadge>*/}
        {/*</CDropdownItem>*/}
        {/*<CDropdownItem href="#">*/}
        {/*  <CIcon icon={cilCommentSquare} className="me-2" />*/}
        {/*  Comments*/}
        {/*  <CBadge color="warning" className="ms-2">*/}
        {/*    42*/}
        {/*  </CBadge>*/}
        {/*</CDropdownItem>*/}
        {/*<CDropdownHeader className="bg-light fw-semibold py-2">Settings</CDropdownHeader>*/}
        {/*<CDropdownItem href="#">*/}
        {/*  <CIcon icon={cilUser} className="me-2" />*/}
        {/*  Profile*/}
        {/*</CDropdownItem>*/}
        {/*<CDropdownItem href="#">*/}
        {/*  <CIcon icon={cilSettings} className="me-2" />*/}
        {/*  Settings*/}
        {/*</CDropdownItem>*/}
        {/*<CDropdownItem href="#">*/}
        {/*  <CIcon icon={cilCreditCard} className="me-2" />*/}
        {/*  Payments*/}
        {/*  <CBadge color="secondary" className="ms-2">*/}
        {/*    42*/}
        {/*  </CBadge>*/}
        {/*</CDropdownItem>*/}
        {/*<CDropdownItem href="#">*/}
        {/*  <CIcon icon={cilFile} className="me-2" />*/}
        {/*  Projects*/}
        {/*  <CBadge color="primary" className="ms-2">*/}
        {/*    42*/}
        {/*  </CBadge>*/}
        {/*</CDropdownItem>*/}
        {/*<CDropdownDivider />*/}
        {/*<CDropdownItem href="#">*/}
        {/*  <CIcon icon={cilLockLocked} className="me-2" />*/}
        {/*  Lock Account*/}
        {/*</CDropdownItem>*/}
      </CDropdownMenu>
    </CDropdown>
  )
}

export default AppHeaderDropdown
